import type { QueryResult } from '@apollo/client';
import { useQuery, gql } from '@apollo/react-hooks';
import { getWorkOrderPropsCounts } from '#/graphql/queries';
import type { GetWorkOrderPropsCountsQuery } from '#/graphql/types';

export const GET_WORK_ORDER_PROPS_COUNTS = gql(getWorkOrderPropsCounts);

const useWorkOrderPropsCounts = (userId?: string | null) => {
  const { data, loading, refetch }: QueryResult<GetWorkOrderPropsCountsQuery> = useQuery(
    GET_WORK_ORDER_PROPS_COUNTS,
    {
      variables: userId ? { userId } : {},
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-first',
    },
  );

  const { workOrders, templates } = data?.getWorkOrderPropsCounts?.data ?? {};

  return { workOrders, templates, loading, refetch };
};

export default useWorkOrderPropsCounts;
